<template>
  <div class="min-h-screen">
    <router-view />

    <CookieConsent button-text="Súhlasím">
      <template v-slot:message>
        Používaním tejto webovej stránky súhlasíte s použitím cookies a <router-link class="underline" :to="{ name: 'terms' }">podmienkami používania</router-link>.
      </template>
    </CookieConsent>

    <svg height="0" style="position: absolute" width="0">
      <symbol id="icon-cheveron-down" viewBox="0 0 20 20">
        <path
          clip-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          fill-rule="evenodd"
        ></path>
      </symbol>
      <symbol id="icon-cheveron-left" viewBox="0 0 20 20">
        <path
          clip-rule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          fill-rule="evenodd"
        ></path>
      </symbol>
      <symbol id="icon-cheveron-right" viewBox="0 0 20 20">
        <path
          clip-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          fill-rule="evenodd"
        ></path>
      </symbol>
      <symbol id="icon-cheveron-up" viewBox="0 0 20 20">
        <path
          clip-rule="evenodd"
          d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
          fill-rule="evenodd"
        ></path>
      </symbol>
      <symbol id="icon-instagram" viewBox="0 0 32 32">
        <path
          d="M20.667 16c0-1.279-.448-2.365-1.343-3.324-.959-.895-2.045-1.343-3.324-1.343s-2.365.448-3.324 1.343c-.895.959-1.343 2.045-1.343 3.324s.448 2.365 1.343 3.324c.959.895 2.045 1.343 3.324 1.343s2.365-.448 3.324-1.343c.895-.959 1.343-2.045 1.343-3.324zm2.557 0c0 1.982-.703 3.708-2.11 5.114-1.406 1.407-3.132 2.11-5.114 2.11-1.982 0-3.708-.703-5.114-2.11-1.407-1.406-2.11-3.132-2.11-5.114 0-1.982.703-3.708 2.11-5.114 1.406-1.407 3.132-2.11 5.114-2.11 1.982 0 3.708.703 5.114 2.11 1.407 1.406 2.11 3.132 2.11 5.114zm1.918-7.48c0 .448-.128.832-.448 1.151-.32.384-.767.512-1.215.512-.447 0-.83-.128-1.15-.512-.384-.32-.512-.703-.512-1.15 0-.448.128-.895.512-1.215.32-.32.703-.448 1.15-.448.448 0 .895.128 1.215.448.32.32.448.767.448 1.215zM16 4.494h-3.324c-.448 0-1.023 0-1.79.064-.703 0-1.343.064-1.854.192a5.305 5.305 0 00-1.279.32c-.639.255-1.15.575-1.662 1.022a5.555 5.555 0 00-1.023 1.662c-.127.32-.255.768-.32 1.279-.127.511-.19 1.15-.19 1.854-.065.767-.065 1.342-.065 1.79v6.648c0 .448 0 1.023.064 1.79 0 .703.064 1.343.192 1.854.064.511.192.959.32 1.279.255.639.575 1.15 1.022 1.662a5.555 5.555 0 001.662 1.023c.32.127.768.255 1.279.32.511.127 1.15.19 1.854.19.767.065 1.342.065 1.79.065h6.648c.448 0 1.023 0 1.79-.064.703 0 1.343-.064 1.854-.192a5.305 5.305 0 001.279-.32 5.555 5.555 0 001.662-1.022 5.555 5.555 0 001.023-1.662c.127-.32.255-.768.32-1.279.127-.511.19-1.15.19-1.854.065-.767.065-1.342.065-1.79v-6.648c0-.448 0-1.023-.064-1.79 0-.703-.064-1.343-.192-1.854a5.305 5.305 0 00-.32-1.279 5.555 5.555 0 00-1.022-1.662 5.555 5.555 0 00-1.662-1.023 5.305 5.305 0 00-1.279-.32c-.511-.127-1.15-.19-1.854-.19-.767-.065-1.342-.065-1.79-.065H16zM30 16c0 2.813 0 4.73-.064 5.817-.128 2.494-.895 4.475-2.237 5.882-1.407 1.342-3.388 2.11-5.882 2.237C20.731 30 18.813 30 16 30s-4.73 0-5.817-.064c-2.494-.128-4.475-.895-5.882-2.237-1.342-1.407-2.11-3.388-2.237-5.882C2 20.731 2 18.813 2 16s0-4.73.064-5.817C2.192 7.689 2.959 5.708 4.3 4.3c1.407-1.342 3.388-2.11 5.882-2.237C11.269 2 13.187 2 16 2s4.73 0 5.817.064c2.494.128 4.475.895 5.882 2.237 1.342 1.407 2.11 3.388 2.237 5.882C30 11.269 30 13.187 30 16z"
          fill-rule="nonzero"
        ></path>
      </symbol>
    </svg>
  </div>
</template>

<script>
import CookieConsent from '@/components/CookieConsent.vue'

export default {
  components: {
    CookieConsent
  },

  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Art.aku.sk | Databáza diel Akadémie Umení v Banskej Bystrici',
      // all titles will be injected into this template
      titleTemplate: '%s | art.aku.sk',
      link: [
        {
          rel: 'canonical',
          href: this.canonicalUrl
        }
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Online databáza diel Akadémie Umení v Banskej Bystrici'
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: 'https://art.aku.sk/art.aku.sk.png'
        }
      ]
    }
  },

  data() {
    return {
      canonicalUrl: undefined
    }
  },

  created() {
    const updateCanonicalUrl = () => {
      // By default, all query parameters are excluded from canonical
      // version of the URL, except for those whitelisted in routes
      // throught the canonicalUrlParams meta attribute
      let query = {}

      // Add whitelisted query params
      if (this.$route.meta.canonicalUrlParams) {
        query = [...this.$route.meta.canonicalUrlParams]
          // order params alphabetically
          .sort()
          // match params from route
          .map((key) => (key in this.$route.query ? { [key]: this.$route.query[key] } : {}))
          // build query object
          .reduce((acc, value) => Object.assign(acc, value), {})
      }

      // Rewrite canonical route?
      const route = this.$route.meta.canonicalRouteName || this.$route.name

      // Resolve canonical route
      const canonical = this.$router.resolve({
        name: route,
        params: this.$route.params,
        query: query
      })

      this.canonicalUrl = window.location.origin + canonical.href
    }

    // generate canonical URL on created
    updateCanonicalUrl()

    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      // update canonical URL
      updateCanonicalUrl()
    })
  }
}
</script>
